import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { JiraProductDiscoveryLogo } from "@atlaskit/logo";
import { media } from "@atlaskit/primitives";
import { SuccessProgressBar } from "@atlaskit/progress-bar";

import { wacToken } from "@/libraries/design/foundations";
import { useIsMobile } from "@/utils/useIsMobile.ts";

import { LoadingAnimation } from "./loading-animation.tsx";

export const LoadingAnimationContainer = () => {
    const isDesktop = !useIsMobile(800);

    return (
        <>
            <div css={backdropContainer}>
                <div css={modalContainer}>
                    <div
                        css={progressContainer}
                        data-testid="signup-provisioning-module-jpd"
                    >
                        <div css={logoContainer}>
                            <JiraProductDiscoveryLogo
                                appearance="brand"
                                size="large"
                            />
                        </div>
                        <div css={animationContainer}>
                            <LoadingAnimation />
                        </div>
                        <div css={progressBarTextContainer}>
                            <div css={progressBarWrapper}>
                                <SuccessProgressBar
                                    ariaLabel="Setting up your discovery workspace"
                                    isIndeterminate
                                />
                            </div>
                            <div
                                css={[isDesktop && systemFonts]}
                                style={{
                                    fontSize: 16,

                                    color: wacToken("color.neutral.light800"),
                                    textAlign: "center"
                                }}
                            >
                                <FormattedMessage
                                    id="SignupProvisioning.inProgressText.jiraProductDiscovery.waitingForProvisioning"
                                    defaultMessage="Adding Jira Product Discovery. Less than a minute remaining..."
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const backdropContainer = css({
    display: "flex",
    position: "fixed",
    justifyContent: "center",
    alignItems: "center",
    insetBlockStart: "0px",
    insetInlineEnd: "0px",
    insetInlineStart: "0px",
    insetBlockEnd: "0px"
});

const modalContainer = css({
    backgroundColor: wacToken("color.neutral.light0"),
    boxShadow:
        // eslint-disable-next-line local/ensure-wac-token-usage
        "0 8px 12px rgba(9, 30, 66, 0.15), 0 0 1px rgba(9, 30, 66, 0.31)",
    borderRadius: "4px",
    overflow: "visible",
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    margin: "auto 32px",
    padding: 24,
    minHeight: 665,
    width: 1130,
    maxWidth: "100%",
    [media.below.sm]: {
        margin: "auto 8px"
    }
});

const progressContainer = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%"
});

const logoContainer = css({
    marginBlockEnd: 32,
    // eslint-disable-next-line
    [" svg"]: {
        height: "32px !important"
    },
    [media.below.sm]: {
        marginBlockEnd: 32
    }
});

const animationContainer = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBlockEnd: 24,
    overflow: "visible",
    padding: "0px",
    // eslint-disable-next-line
    ["> div"]: {
        height: 500,
        maxWidth: "none",
        overflow: "visible"
    },
    width: "100%",
    maxWidth: "none",
    [media.below.sm]: {
        padding: "0px",
        marginBlockEnd: 24,
        // eslint-disable-next-line
        ["> div"]: {
            height: 406,
            maxWidth: "none",
            overflow: "visible"
        }
    }
});

const progressBarTextContainer = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBlockStart: 0,
    marginBlockEnd: 0,
    textAlign: "center",
    width: "100%"
});

const progressBarWrapper = css({
    width: "460px", // Slightly longer than typical text width
    marginBlockStart: 24, // Equal space from animation above
    marginBlockEnd: 20, // Space to text below
    [media.below.sm]: {
        width: "360px"
    }
});

const systemFonts = css({
    fontFamily: "var(--atlassian-recommended-system-fonts)"
});
